









import { Component, Vue, Prop } from 'vue-property-decorator'
import OzContainedButton, { OzContainedButtonColorScheme } from 'library/v4/components/OzContainedButton.vue'
import OzLoadingText from 'library/v4/components/OzLoadingText.vue'

@Component({ components: { OzContainedButton, OzLoadingText } })
export default class MembershipTierActionButton extends Vue {
  @Prop({ default: false }) isProcessing!: boolean
  @Prop() buttonText!: string
  @Prop() processingText!: string

  OzContainedButtonColorScheme = OzContainedButtonColorScheme
}
